import React, { useEffect, useMemo } from 'react';
import { AppContext } from '../provider/AppContextProvider';
import { AdsEntry } from '../helper/interfaces';

declare global {
  interface Window {
    traffective: any;
  }
}

interface AdProps {
  counter?: number,
  ads?: AdsEntry
}

export function getContentAd(counter: number) {
  return <Ad counter={counter} />
}

export function getRessortAd(ads: AdsEntry) {
  return <Ad ads={ads} />
}

export default function Ad({ counter, ads }: AdProps) {
  const { adsReady } = React.useContext(AppContext);
  const adLoadedCount = React.useRef(0);
  const [isAdLoaded, setIsAdLoaded] = React.useState(false);
  const [traffectiveRefreshCalled, setTraffectiveRefreshCalled] = React.useState(false);

  const showAd = (process.env.NEXT_PUBLIC_SHOW_ADS === "true") ? true : false
  let adCounter = counter || 0
  
  try {
    if(ads && ads.className) {
      const regex = /\d+/;
      const match = ads.className.match(regex);

      if (match) {
        adCounter = parseInt(match[0], 10);
      } 
    }
  } catch (error: any) {
    console.error("Invalid ad class name", ads?.className, error);
  }
  const divData = useMemo(() => {
    if(ads) {
      return { id: ads.id, class: ads.className } 
    }
    else {
      return { id: `ad-Mobile_Pos${adCounter}`, class: `Mobile_Pos${adCounter}` } 
    }
  }, [adCounter, ads]
  )

  useEffect(() => {
    if(process.env.NEXT_PUBLIC_SHOW_ADS === "true" && adsReady && showAd) {
      if(window.traffective && window.traffective.refreshSlot) {
        window.traffective.refreshSlot(divData.class, divData.id);
        setTraffectiveRefreshCalled(true);
        // let attempts = 0;
        // const maxAttempts = 6; // 3 seconds total (500ms * 6)
        
        // const checkAdLoaded = () => {
        //   const adElement = document.getElementById(divData.id);
        //   if (adElement && adElement.innerHTML.trim() !== '') {
        //     setIsAdLoaded(true);
        //     return;
        //   }
          
        //   attempts++;
        //   if (attempts < maxAttempts) {
        //     setTimeout(checkAdLoaded, 500);
        //   }
        // };

        // // Start checking after a short delay to allow initial render
        // const initialTimeout = setTimeout(checkAdLoaded, 100);
        // return () => clearTimeout(initialTimeout);
      }
    }
  }, [divData.id, adsReady, adCounter, showAd])

  return (
    <React.Fragment>
      {showAd &&<>
       {/* {process.env.NEXT_PUBLIC_APP_ENV !== "production"  && <>
        adsReady: {adsReady ? 'true' : 'false'} showAd: {showAd ? 'true' : 'false'} divData: {divData.id} {divData.class} traffectiveRefreshCalled: {traffectiveRefreshCalled ? 'true' : 'false'} isAdLoaded: {isAdLoaded ? 'true' : 'false'}</>
        } */}
        <div className="ad-row">
          <div id={divData.id} className={divData.class}></div>
        </div>
      </>
      }
    </React.Fragment>
  );
}